import { SmartLink } from "@selector/shared/components";
import type { FC } from "react";
import { Card, CardRowSimple, type GridCard, Tag } from "widgets";

import { getGeneTypeColor } from "@/app-utils/color.ts";
import { createNuSequenceLengthString } from "@/app-utils/string.ts";
import type { Transcript } from "@/graphql.ts";
import { getUserDisplayName } from "@/modules/users/utils/user.js";
import { SEQUENCE_TYPE_LABEL, uploaderFieldLabel } from "@/settings/settings.ts";

import style from "../../core/cards/styles/Card.module.scss";

export interface ITranscriptCardProps extends GridCard {
  transcript: Transcript;
  blastContext?: boolean;
}

const TranscriptCard: FC<ITranscriptCardProps> = (props) => {
  const transcript: Transcript = props.transcript;
  if (!transcript) {
    return null;
  }

  const sequenceTypeLabel: string = SEQUENCE_TYPE_LABEL[transcript.sequenceTypeId];

  return (
    <Card key="transcript-info-card" title={"Transcript Info"}>
      <CardRowSimple label={"Type"}>
        <div className={style.tags_list}>
          <Tag intentColor={getGeneTypeColor(sequenceTypeLabel)}>{sequenceTypeLabel}</Tag>
        </div>
      </CardRowSimple>
      <CardRowSimple
        label={"Sequence ID (accession.version)"}
        value={
          props.blastContext ? (
            <SmartLink to={`/transcript/${transcript.id}`}>{transcript.sequenceId}</SmartLink>
          ) : (
            transcript.sequenceId
          )
        }
      />
      <CardRowSimple label={"Name"} value={transcript.name} />
      {transcript.species && <CardRowSimple label={"Species"} value={<em>{transcript.species.name}</em>} />}
      <CardRowSimple label={"Description"} value={transcript.description} />
      <CardRowSimple label={"Length"} value={createNuSequenceLengthString(transcript.length)} />
      <CardRowSimple label={uploaderFieldLabel} value={getUserDisplayName(transcript.creator)} />
    </Card>
  );
};

export { TranscriptCard };
